"use strict";

var _react = _interopRequireDefault(require("react"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

function _objectWithoutProperties(a, b) {
  if (null == a) return {};

  var c,
      d,
      e = _objectWithoutPropertiesLoose(a, b);

  if (Object.getOwnPropertySymbols) {
    var f = Object.getOwnPropertySymbols(a);

    for (d = 0; d < f.length; d++) {
      c = f[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
    }
  }

  return e;
}

function _objectWithoutPropertiesLoose(a, b) {
  if (null == a) return {};
  var c,
      d,
      e = {},
      f = Object.keys(a);

  for (d = 0; d < f.length; d++) {
    c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
  }

  return e;
}

var _default = function _default(a) {
  var b = a.field,
      c = a.styledComponents,
      d = a.component,
      e = _objectWithoutProperties(a, ["field", "styledComponents", "component"]),
      f = b.cssClass,
      g = b.width,
      h = (c || !1).Box,
      i = void 0 === h ? "div" : h,
      j = d;

  return j ? _react["default"].createElement(i, {
    width: g,
    className: "form-field ".concat(f)
  }, _react["default"].createElement(j, _extends({
    field: b,
    styledComponents: c
  }, e))) : "";
};

exports["default"] = _default;